import { PercentageBar } from '../percentage-bar/percentage-bar';

interface ValueBreakdownItemProps {
  value: string;
  label: string;
  percentage: string;
}

export function ValueBreakdownItem({ value, label, percentage }: ValueBreakdownItemProps) {
  return (
    <div className="grid grid-cols-[max-content_1fr] gap-4">
      <div className="flex flex-col">
        <span className="text-3xl text-[#3F98B4]">{value}</span>
        <span className="text-[0.86625rem]">{label}</span>
      </div>
      <PercentageBar className="mt-2 h-[13px]" value={percentage} />
    </div>
  );
}
